<template>
  <div>
    <div class="superheading-container">
      <Chevron
        :rtl-override="true"
        :expanded="expanded"
        @expand="onExpand"
      />
      <a href @click.prevent="onSelection">{{ superheading.title }}</a>
    </div>
    <div v-if="expanded">
      <div v-if="rows.length">
        <span
          v-for="(row, index) in rows"
          :key="`row-${index}`"
        >
          <BrowseRow
            :row="row"
            :work="work"
            @selected="selection => $emit('selected', selection)"
          />
        </span>
      </div>
      <div v-else>
        <small>{{ $t('loading') }}</small>
      </div>
    </div>
  </div>
</template>

<script>
  import Chevron from '../Chevron.vue';
  import BrowseRow from './BrowseRow.vue';
  import { COLLAPSE_ALL_BROWSE_CONTENT } from '../../constants';

  export default {
    components: {
      BrowseRow,
      Chevron,
    },
    props: ['superheading', 'work'],
    data() {
      return {
        expanded: false,
      };
    },
    computed: {
      rows() {
        return this.superheading.sectionCollations;
      },
      collapse() {
        return this.$store.state.collapseAll;
      },
    },
    watch: {
      collapse(newVal) {
        if (newVal === true) {
          this.expanded = false;
        }
      },
    },
    methods: {
      onSelection() {
        this.$emit('selected', {
          work: this.work.urn,
          idx: this.superheading.firstSectionIdx,
        });
      },
      onExpand() {
        this.expanded = !this.expanded;
        this.$store.dispatch(COLLAPSE_ALL_BROWSE_CONTENT, { status: false });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../variables';
  .superheading-container {
    display: flex;
    span {
      padding-top: 10px;
    }
    margin-bottom: 10px;
  }
</style>
